import { observable, makeObservable } from "mobx";
import { fetchObVitals } from "../../serviceCalls";
import { MODULE_ID } from "../../shared/moduleIds";

export default class ObVitalsStore {
  loading;
  vitals;

  constructor() {
    makeObservable(this, {
      loading: observable,
      vitals: observable,
    });
  }

  fetchObVitals({ adusername, asmpid }) {
    this.loading = true;
    return fetchObVitals({
      adusername: adusername,
      asmpid: asmpid,
      moduleId: MODULE_ID.OBSTETRICS,
    })
      .then((vitals) => (this.vitals = vitals))
      .finally(() => (this.loading = false));
  }
}
